import { format, parseISO } from 'date-fns';

export const appendZone = (value: string) =>
  value && 'z' !== value.substr(-1).toLowerCase() ? `${value}Z` : value;

export const parseStringDate = (date: string) => parseISO(date);

export const toSimpleDate = (date: Date) =>
  format(new Date(date), 'yyyy-MM-dd');
export const toSimpleDateDots = (date: Date) =>
  format(new Date(date), 'dd.MM.yyyy');
export const toSimpleDateTime = (date: Date) =>
  format(new Date(date), 'yyyy-MM-dd HH:mm');
